import { getRuntimeConfig } from '@/shared/runtimeConfig';

/**
 * Konfigurace Phoenix-On-Top režimu (Phoenix-primary, Magic-embedded).
 *
 * Aktivace přes `LegacyMagic.PhoenixOnTop` v backendovém appsettings — přijde frontendu přes
 * `/api/config/runtime`. Když je aktivní, Phoenix mountuje `<MagicControlBridge />`
 * a hlavní menu se plní položkami z Magicu.
 *
 * Multi-tenant deploy: každý zákazník má vlastní appsettings, frontend bundle stejný.
 */
export function isPhoenixOnTopMode(): boolean {
  const cfg = getRuntimeConfig().legacyMagic;
  return cfg.phoenixOnTop && cfg.baseUrl.length > 0;
}
